// Shared constants + formatters for the Property IC module.
// Extracted from PropertyIC.jsx in iter-13 refactor.

export const TYPES = ["Business", "Leisure - North", "Leisure - South"];
export const VINTAGES = ["New", "Old"];
export const MODELS = ["COCO", "FOCO"];
export const DORM_SIZES = [4, 6, 8, 10, 12, 16];
export const BD_MEMBERS = ["Vardan", "Nikhil", "Pankaj", "Pallavi", "Stan", "Vamsi"];

export const newMemberRow = (m) => ({
  member: m,
  dorm_occ_pct: 60,
  dorm_adr: 900,
  private_occ_pct: 50,
  private_adr: 2200,
});

export const avgKey = (arr, k) => {
  const v = arr.map((x) => Number(x[k]) || 0).filter((x) => !isNaN(x));
  return v.length ? v.reduce((a, b) => a + b, 0) / v.length : 0;
};

export const fmtINR = (v) =>
  v == null || isNaN(v) ? "—" : "₹" + Math.round(v).toLocaleString("en-IN");
export const fmtL = (v) =>
  v == null || isNaN(v) ? "—" : "₹" + (v / 100000).toFixed(1) + "L";
export const fmtPct = (v) =>
  v == null || isNaN(v) ? "—" : `${Number(v).toFixed(1)}%`;
export const fmtNum = (v) =>
  v == null || isNaN(v) ? "—" : Number(v).toLocaleString("en-IN");
export const fmtDate = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : "—";

const DECISION_TONES = {
  Approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Rejected: "bg-rose-50 text-rose-700 border-rose-200",
  "Under Discussion": "bg-amber-50 text-amber-700 border-amber-200",
  Draft: "bg-purple-50 text-purple-700 border-purple-200",
};
const DECISION_TONE_DEFAULT = "bg-zinc-50 text-zinc-600 border-zinc-200";

export const decisionTone = (d) => DECISION_TONES[d] || DECISION_TONE_DEFAULT;

// Auto-select on focus so leading 0 gets replaced cleanly
export const numProps = { onFocus: (e) => e.target.select() };
